import React from 'react';

import { AvailabilityPreferencesConfirmation } from '../components/AvailabilityPreferencesConfirmation/AvailabilityPreferencesConfirmation';

export type AvailabilityPreferencesConfirmPageProps = {
  name?: string;
};

export const AvailabilityPreferencesConfirmPage = ({
  name = 'AVAILABILITY_PREFERENCES_CONFIRM_PAGE',
}: AvailabilityPreferencesConfirmPageProps) => {
  return (
    <div data-test={name}>
      <AvailabilityPreferencesConfirmation />
    </div>
  );
};
